<template>
  <section
    class="featured sliderhome current-1 wrapper"
    data-hash="8"
    id="heroheader"
  >
    <div class="dwere-vid">
      <modal name="my-first-modal" @click="hide">
        <div class="modal-vid">
          <a @click="hide" class="modal-close"></a>
          <iframe
            width="560"
            height="315"
            src="https://youtu.be/RtVZOHOOg68?si=V-HZyr2qh5koYrBo"
            frameborder="0"
            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </modal>

      <div class="actions-wrap">
        <div class="trailerGif">
          <div @click="show" class="play-button-outer">
            <div @click="show" class="play-button"></div>
          </div>
        </div>
        <div class="button-wrap">
          <div class="button-wrap-container">
            <div class="linkTitle">
              Out Now On
            </div>
            <div class="links">
              <a
                class="store-link"
                href="https://dwerve.com/switch"
                rel="noopener noreferrer"
                target="_blank"
              >
                <div class="nintendo-btn steam-btn hvr-grow-shadow">
                  <img
                    src="static/assets/images/nintendo-switch-logo.jpeg"
                    alt="nintendo"
                  />
                  <span>Nintendo Switch</span>
                </div>
              </a>
              <a
                class="store-link"
                href="https://dwerve.com/epic"
                rel="noopener noreferrer"
                target="_blank"
              >
                <div class="epic-btn steam-btn hvr-grow-shadow">
                  <img
                    src="static/assets/images/epic-games-icon.png"
                    alt="epic-store"
                  />
                  <span>Epic Games Store</span>
                </div>
              </a>
              <a
              class="store-link"
              href="https://www.humblebundle.com/store/dwerve"
              rel="noopener noreferrer"
              target="_blank"
            >
              <div class="steam-btn humble-btn hvr-grow-shadow">
                <img
                  src="static/assets/images/logo-humble-bundle-icon.png"
                  alt="dwerve-humble-store"
                />
                <span>Humble Store</span>
              </div>
            </a>
            <a
              class="store-link"
              href="https://store.steampowered.com/app/1132760/Dwerve/"
              rel="noopener noreferrer"
              target="_blank"
            >
              <div class="steam-btn hvr-grow-shadow">
                <img
                  src="static/assets/images/steam-icon-19.png"
                  alt="dwerve-steam"
                />
                <span>Steam Store</span>
              </div>
            </a>
            </div>

          </div>

          <!--
            <a href="https://url.halfhumangames.com/kickstarter-ws" target="_blank" class="kickstarter">Back now on <img src="/static/assets/images/Kickstarter_Logo_old_text.png" alt="dwerve kickstarter"> </a>
          -->
        </div>
      </div>
    </div>

    <ul
      id="scene0"
      class="current scene game-featured game-1"
      data-friction-x="0.1"
      data-friction-y="0.1"
      data-scalar-x="45"
      data-limit-x="190"
      data-limit-y="220"
      data-scalar-y="25"
    >
      <li class="layer" data-depth="0">
        <img
          src="/static/assets/images/tinified/1.png"
          alt="dwerve"
          class="background"
        />
      </li>

      <li class="layer" data-depth="0">
        <img
          src="/static/assets/images/tinified/2.png"
          alt="dwerve"
          class="background"
        />
      </li>
      <li class="layer higher-z-1" data-depth="0">
        <img
          src="/static/assets/images/tinified/4.png"
          alt="dwerve"
          class="background"
        />
      </li>
      <li class="layer higher-z-1" data-depth="0.06">
        <img
          src="/static/assets/images/tinified/6.png"
          alt="dwerve"
          class="background"
        />
      </li>
      <li class="layer" data-depth="0.1">
        <img
          src="/static/assets/images/tinified/3.png"
          alt="dwerve"
          class="background"
        />
      </li>
      <li class="layer higher-z-2 zoom-img" data-depth="0.2">
        <img
          src="/static/assets/images/tinified/7.png"
          alt="dwerve"
          class="background"
        />
      </li>

      <KickstarterCTA></KickstarterCTA>
      <li class="layer dwerve-layer higher-z-3" data-depth="0.3">
        <img
          src="/static/assets/images/Dwerve-Title-PJ.png"
          alt="dwerve"
          class="game-title dwerveTitle"
        />
      </li>
    </ul>

    <div class="text-scroll-inner"><!-- <SendyInline></SendyInline> --></div>
    <!-- <FollowModal></FollowModal> -->
    <!-- <SendyModal></SendyModal> -->
    <iframe
      height="50px"
      scrolling="no"
      src="https://embed.keymailer.co/g/games/85266/request_button/_2b46f56011"
      style="border: none"
      width="200px"
    ></iframe>
  </section>
</template>

<script>
import VTooltip from "v-tooltip";
import ModalVideo from "modal-video";
import Mailtrain from "@/views/Home/MailTrain.vue";
import KickstarterCTA from "@/views/Home/KickstarterCTA.vue";
import FollowModal from "@/views/Home/FollowModal.vue";
import SendyModal from "@/views/Home/SendyModal.vue";
import SendyInline from "@/views/Home/SendyInline.vue";
export default {
  data: function() {
    return {
      isActive: false,
      isEnabled: true
    };
  },
  methods: {
    makeActive() {
      this.isActive = !this.isActive;
      $(".popover").addClass("test3");
    },
    resizeGIFs() {
      var windowWidth = document.documentElement.clientWidth;
      var windowHeight = document.documentElement.clientHeight;
      var actualBackgroundWidth = 1920;
      var actualBackgroundHeight = 1080;
      var targetAspectRatio = 1920 / 1080;
      var actualAspectRatio = windowWidth / windowHeight;
      var actualSliceWidth = 533;
      var actualSliceHeight = 403;
      var sliceAspectRatio = actualSliceWidth / actualSliceHeight;
      var actualSliceDistanceTop = 409;
      var actualSliceDistanceRight = 407;
      var sliceDistanceAspectRatio =
        actualSliceDistanceRight / actualSliceDistanceTop;
      if (actualAspectRatio <= targetAspectRatio) {
        var sliceHeight =
          (actualSliceHeight * windowHeight) / actualBackgroundHeight;
        var sliceWidth = sliceHeight * sliceAspectRatio;
        var sliceTop =
          (actualSliceDistanceTop * windowHeight) / actualBackgroundHeight;
        var sliceRight = sliceTop * sliceDistanceAspectRatio;
      } else {
        var sliceWidth =
          (actualSliceWidth * windowWidth) / actualBackgroundWidth;
        var sliceHeight = sliceWidth / sliceAspectRatio;
        var sliceRight =
          (actualSliceDistanceRight * windowWidth) / actualBackgroundWidth;
        var sliceTop = sliceRight / sliceDistanceAspectRatio;
      }
      // document.getElementById("slice-tower").style.top = sliceTop + "px";
      // document.getElementById("slice-tower").style.right = sliceRight + "px";
      // document.getElementById("slice-tower").style.height = sliceHeight + "px";
      // document.getElementById("slice-tower").style.width = sliceWidth + "px";
      var actualArrowWidth = 348;
      var actualArrowHeight = 250;
      var arrowAspectRatio = actualArrowWidth / actualArrowHeight;
      var actualArrowDistanceTop = 224;
      var actualArrowDistanceRight = 1220;
      var arrowDistanceAspectRatio =
        actualArrowDistanceRight / actualArrowDistanceTop;
      if (actualAspectRatio <= targetAspectRatio) {
        var arrowHeight =
          (actualArrowHeight * windowHeight) / actualBackgroundHeight;
        var arrowWidth = arrowHeight * arrowAspectRatio;
        var arrowTop =
          (actualArrowDistanceTop * windowHeight) / actualBackgroundHeight;
        var arrowRight = arrowTop * arrowDistanceAspectRatio;
      } else {
        var arrowWidth =
          (actualArrowWidth * windowWidth) / actualBackgroundWidth;
        var arrowHeight = arrowWidth / arrowAspectRatio;
        var arrowRight =
          (actualArrowDistanceRight * windowWidth) / actualBackgroundWidth;
        var arrowTop = arrowRight / arrowDistanceAspectRatio;
      }
      // document.getElementById("crossbow").style.top = arrowTop + "px";
      // document.getElementById("crossbow").style.right = arrowRight + "px";
      // document.getElementById("crossbow").style.height = arrowHeight + "px";
      // document.getElementById("crossbow").style.width = arrowWidth + "px";
    },
    setZIndex() {
      if (document.getElementById("myFollowModal").style.display == "block") {
        document.getElementById("navbar").style.zIndex = "1";
        document.getElementById("socialNav").style.zIndex = "1";
      } else {
        document.getElementById("navbar").style.zIndex = "2";
        document.getElementById("socialNav").style.zIndex = "2";
      }
    },
    openVideo() {
      new ModalVideo(".js-modal-video", { channel: "youtube" });
    },
    show() {
      this.$modal.show("my-first-modal");
    },
    hide() {
      this.$modal.hide("my-first-modal");
    }
  },
  mounted() {
    //this.$nextTick(function() {
    //window.addEventListener("resize", this.resizeGIFs);
    // this.resizeGIFs();
    // });
  },
  beforeDestroy() {
    // window.removeEventListener("resize", this.resizeGIFs);
  },
  components: {
    Mailtrain,
    FollowModal,
    SendyModal,
    SendyInline,
    KickstarterCTA
  }
};
</script>

<style scoped>
li.layer.zoom-img img {
  width: 108% !important;
  left: -65px !important;
  bottom: -35px;
}
.linkTitle {
    font-size: 49px;
    font-family: Digitalt;
    color: #fff;
}
.higher-z-1 {
  z-index: 1;
}
.higher-z-2 {
  z-index: 2;
}
h1.comingSoonText span.bigger-text {
  font-size: 53px;
}
.epic-btn.steam-btn {
  background: linear-gradient(225deg, #313131 47%, #666666 41%);
}
.higher-z-3 {
  z-index: 3;
}
@media all and (orientation: landscape) and (max-width: 900px) {
  .steam-btn {
    width: 231px !important;
  }
  .steam-btn span {
    font-size: 20px !important;
  }
  .button-wrap {
    top: -64px !important;
  }
  li.layer.dwerve-layer .dwerveTitle {
    top: -2% !important;
    width: 279px !important;
    margin-top: auto !important;
  }
  .steam-btn img {
    width: 48px !important;
  }

  h1.comingSoonText span {
    font-size: 77px;
  }

  .play-button-outer {
    width: 8em !important;
    height: 8em !important;
  }
  .play-button {
    top: 10% !important;
    left: 7px !important;
  }
}
@media all and (orientation: landscape) and (max-width: 1040px) and (min-width: 900px) {
  li.layer.dwerve-layer .dwerveTitle {
    top: -28% !important;
    width: 432px !important;
  }
}
.v-popover a.tooltip-target {
  font-size: 15px;
  font-family: "Titillium Web", sans-serif;
  cursor: pointer;
  font-display: swap;
  color: #fff;
  font-weight: 700;
  text-decoration: none;
  margin-top: 10px;
  display: block;
  text-shadow: 1px 1px 2px rgba(0, 0, 0, 0.1);
}
a.tooltip-target:before {
  content: "\f0da";
  font-family: "Font Awesome 5 Free";
  padding-right: 10px;
  color: #267fbc;
}
.open a.tooltip-target {
  content: "\F0D7" !important;
}
.steam-btn img {
  width: 66px;
  height: 66px;
}

h1.comingSoonText {
  width: 100%;
  font-size: 42px;
  font-family: Digitalt;
  padding-left: 9px;
  text-shadow: 1px 1px 2px #081a42;
  left: 0;
  color: #fff;
  filter: drop-shadow(0 0 0.75rem #5fc3db);
  margin-bottom: 10px;
}

.steam-btn {
  color: #fff;
  width: 300px;
  text-align: left;
  background: linear-gradient(225deg, #1274a7 47%, #081a42 41%);
  margin: auto;
  border-radius: 43px;
  box-shadow: 1px 5px 12px 0px rgba(0, 0, 0, 0.75);
  margin-bottom: 20px;
}
.steam-btn span {
  font-size: 25px;
  font-family: Digitalt;
  top: 5px;
  padding-left: 9px;
  text-shadow: 1px 1px 2px #081a42;
  position: relative;
  font-weight: 400;
}
.hvr-grow-shadow {
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: perspective(1px) translateZ(0);
  transform: perspective(1px) translateZ(0);
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: box-shadow, transform;
  transition-property: box-shadow, transform;
}
.hvr-grow-shadow:hover,
.hvr-grow-shadow:focus,
.hvr-grow-shadow:active {
  box-shadow: 0 16px 17px -7px rgb(17, 57, 84);
}

.green-man-btn.steam-btn {
  background: linear-gradient(225deg, #00e203 47%, #093609 41%);
}

.nintendo-btn {
  background: linear-gradient(225deg, #1cbde6 47%, #ff6461 41%);
}

.nintendo-btn img {
  border-radius: 50%;
}

.steam-btn.humble-btn {
  background: linear-gradient(225deg, #d1011a 47%, #3a0209 41%);
}

.trailerGif {
  height: auto;
  width: 100%;
  margin-bottom: 150px;
}
a.modal-close {
  position: absolute;
  width: 100%;
  height: 100%;
}
.modal-vid iframe {
  width: 100% !important;
  max-width: 1280px !important;
  height: 100%;
  max-height: 720px;
}
.modal-vid {
  display: flex;
  height: 100%;
  width: 100%;
  justify-content: center;
  align-items: center;
}
a.kickstarter img {
  max-width: 242px;
  padding-bottom: 9px;
  display: block;
  margin: auto;
}
@media only screen and (max-width: 638px) {
  a.kickstarter {
    padding: 17px 20px !important;
    font-size: 20px !important;
  }
  .play-button-outer {
    width: 7em !important;
    height: 7em !important;
    top: inherit !important;
  }
  .play-button {
    border-width: 1.5em 0 1.5em 3em !important;
    top: 27% !important;
  }
  a.store-link {
    padding: 5px !important;
  }
}

a.kickstarter:hover {
  text-decoration: none;
  animation: anim-glow 1s ease-in infinite;
}
a.kickstarter {
  position: relative;
  color: #fff;
  animation: anim-glow 1s ease-in infinite;
  letter-spacing: 1px;
  line-height: 1.9;
  font-size: 24px;
  display: block;
  padding: 11px 37px;
  font-family: "Roboto Condensed", sans-serif;
  font-weight: 700;
  text-align: center;
  margin: auto;
  background: linear-gradient(-135deg, #05ce78, #28b799);
  border-radius: 44px;
  box-shadow: 1px 5px 12px 0px rgba(0, 0, 0, 0.75);
  font-size: 22px;
  text-shadow: 1px 1px 2px rgb(0 0 0 / 11%);
}
a.kickstarter:link {
  text-decoration: none;
}
i.fas.fa-chevron-down.animated.pulse.animated-infinite {
  bottom: 11px;
  position: absolute;
  text-align: center;
  width: 100%;
}
.fa-chevron-down:before {
  color: rgba(255, 255, 255, 0.30196078431372547);
  font-size: 20px;
}
@font-face {
  font-family: Digitalt;
  font-display: swap;
  src: url(/static/assets/lib/Digitalt.otf);
}
.follow-title {
  font-family: Digitalt;
  color: #33adff;
  font-size: 58px;
}
.follow-subtitle {
  font-family: Digitalt;
  font-size: 26px;
}
.follow-subtitle2 {
  font-family: Digitalt;
  font-size: 23px;
  color: #febf45;
  margin: 0 0 0px;
  line-height: 1;
  font-weight: 100;
  padding-top: 0px;
}
.slice-tower,
.game-title .crossbow {
  min-width: unset;
  width: unset;
  max-width: unset;
  min-height: unset;
  height: unset;
  margin: 0 auto;
}

.follow-btn {
  width: 402px;
}

.crossbow {
  position: absolute;
  object-fit: contain;
  left: unset;
  bottom: unset;
  min-width: unset;
  min-height: unset;
}

.slice-tower {
  position: absolute;
  left: unset;
  object-fit: contain;
  bottom: unset;
}

.subtitle-img {
  z-index: 9;
  left: 19%;
  top: 2%;
  position: absolute;
}

.fade-in.three {
  -webkit-animation-delay: 2.6s;
  -moz-animation-delay: 2.6s;
  animation-delay: 2.6s;
}

.fade-in {
  opacity: 0; /* make things invisible upon start */
  -webkit-animation: fadeIn ease-in 1;
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;

  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;

  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  animation-duration: 1s;
}
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.follow::before,
.follow::after {
  position: absolute;
  content: "";
  transition: all 0.5s;
}
.follow {
  position: absolute;
  top: 93%;
  left: 51%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.suscribe {
  margin-left: 50%;
  margin-top: 48%;
  transform: translateZ(600px);
}

.parallax {
  position: relative;
  width: 100%;
  height: 800px;
  left: 0;
}

.cd-floating-background {
  position: absolute;
  right: 0;
}
.cd-background-wrapper {
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background-size: cover;
  position: relative;
}

.dwerveTitle {
  position: absolute;
  margin: auto;
  object-fit: cover;
  object-position: 50% 100% !important;
  height: auto !important;
  bottom: 0;
  width: 710px !important;
  left: 3% !important;
  min-width: unset;
  min-height: unset;
}

.background {
  position: absolute;
  z-index: -1;
  min-width: unset;
  margin: auto;
  width: 100% !important;
  min-width: unset;
  min-height: unset;
  top: unset;
  bottom: unset;
  object-fit: cover;
  object-position: 100% 87% !important;
}

@media (min-aspect-ratio: 16 / 9) {
  .images {
    width: 104.17%;
    height: auto;
    margin-top: 0;
    object-position: 95.83% 100%;
  }
  .dwerveTitle {
    /* bottom: 0;
    top: -48% !important;
    margin-top: auto !important; */
    bottom: 0;
    top: -22% !important;
  }
  .follow {
    top: 90%;
  }
  .background {
    height: 100%;
  }
}

@media (max-aspect-ratio: 16 / 9) {
  .images {
    width: 104.17%;
    object-position: 95.83% 100%;
  }
  .dwerveTitle {
    bottom: 0;
    top: -22% !important;
  }
  .follow {
    top: 87%;
  }
  .background {
    height: 100%;
  }
}

@media only screen and (max-width: 1070px) {
  .background {
    object-position: 50% 100% !important;
  }

  .follow {
    font-size: 5vw;
  }
  .slice-tower {
    display: none;
  }
}

.spider-hanging {
  position: absolute;
  top: -115%;
  width: 15%;
}
.overlay {
  /* Height & width depends on how you want to reveal the overlay (see JS below) */
  height: 100%;
  width: 100%;
  position: fixed; /* Stay in place */
  z-index: 1; /* Sit on top */
  left: 0;
  top: 0;
  display: none;
  background-color: rgb(0, 0, 0); /* Black fallback color */
  background-color: #0d182de6; /* Black w/opacity */
  overflow-x: hidden; /* Disable horizontal scroll */
  transition: 0.5s; /* 0.5 second transition effect to slide in or slide down the overlay (height or width, depending on reveal) */
}

/* Position the content inside the overlay */
.overlay-content {
  position: relative;
  top: 21%;
  width: 54%;
  left: 25%;
  text-align: center;
  margin-top: 30px;
}

/* The navigation links inside the overlay */
.overlay a {
  padding: 8px;
  text-decoration: none;
  font-size: 36px;
  color: #fff;
  display: block; /* Display block instead of inline */
  transition: 0.3s; /* Transition effects on hover (color) */
}
.overlay-content input#semail {
  height: 69px;
}
@media screen and (max-height: 750px) {
  .overlay-content {
    position: relative;
    top: 30%;
    width: auto;
    left: 0;
    text-align: center;
    margin-top: 0;
  }
}

/* When you mouse over the navigation links, change their color */
.overlay a:hover,
.overlay a:focus {
  color: #f1f1f1;
}

/* Position the close button (top right corner) */
.overlay .closebtn {
  position: absolute;
  top: 20px;
  right: 45px;
  font-size: 60px;
  z-index: 1;
}

/* When the height of the screen is less than 450 pixels, change the font-size of the links and position the close button again, so they don't overlap */
@media screen and (max-height: 450px) {
  .overlay a {
    font-size: 20px;
  }
  .overlay .closebtn {
    font-size: 40px;
    top: 15px;
    right: 35px;
  }
}
.follow-form {
  padding-top: 0px;
  width: 53%;
  margin-left: 24%;
}
.fade-in-overlay {
  opacity: 1;
  animation-name: fadeInOpacity;
  animation-iteration-count: 1;
  animation-timing-function: ease-in;
  animation-duration: 0.2s;
}

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
#heroheader .col-xs-12 {
  padding-left: 0%;
  padding-right: 0%;
  z-index: 1;
}
@media only screen and (max-width: 768px) {
  .col-xs-12 {
    padding-left: 13%;
    padding-right: 13%;
  }
}
@media only screen and (max-width: 768px) {
  .col-xs-12 {
    padding-left: 13%;
    padding-right: 13%;
  }

  section#cta1 button {
    width: 112px;
    font-size: 22px;
    padding-left: 10px !important;
  }
}
/* Mailtrain styles */
#heroheader .form-group.email label {
  display: none;
}
#heroheader .form-group {
  display: inline-block;
}

#heroheader .form-group.email input {
  top: -9px;
  left: 6px;
}
#heroheader .form-group.email label {
  display: none;
}
/* div#mailtrain-subscription-widget-rJfit7pAM h3 {
  display: none;
} */
@media only screen and (min-device-width: 300px) and (max-device-width: 768px) {
  .trailerGif {
    margin-bottom: 50px;
  }
}
.dwere-vid {
  position: absolute;
  width: 100%;
  height: 100%;
  text-align: center;
  z-index: 1;
  display: flex;
  align-items: center;
  flex-direction: column;
  bottom: 0px;
  justify-content: center;
}
.dwere-vid iframe {
  margin-top: 100px;
  z-index: 1;
  padding: 10px;
  background: #010100;
  box-shadow: 0px 5px 15px rgb(0 0 0);
}
.sliderhome {
  overflow: visible;
}
@-webkit-keyframes anim-glow {
  0% {
    box-shadow: 0 0 #61ef61;
  }
  100% {
    box-shadow: 0 0 10px 8px transparent;
    border-width: 2px;
  }
}
@keyframes anim-glow {
  0% {
    box-shadow: 0 0 #61ef61;
  }
  100% {
    box-shadow: 0 0 10px 8px transparent;
    border-width: 2px;
  }
}
li.layer.dwerve-layer {
  transform: translate3d(-46.4px, -143.4px, 0px) !important;
}
@media only screen and (max-width: 640px) {
  .dwerveTitle {
    top: -26% !important;
    width: 80% !important;
    left: 7% !important;
  }
}
.play-button-outer {
  margin: auto;
  width: 12em;
  height: 12em;
  border: 10px solid rgb(255 255 255 / 65%);
  cursor: pointer;
  border-radius: 50%;
}

.play-button {
  margin: 0 auto;
  top: 25%;
  left: 5px;
  position: relative;
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 2.5em 0 2.5em 5em;
  border-color: transparent transparent transparent rgb(255 255 255 / 81%);
  opacity: 1;
}

.play-button-outer:hover {
  background-color: rgba(0, 0, 0, 0.5);
}

.play-button-outer:hover .play-button {
  opacity: 1;
}
.button-wrap {
  width: 100%;
  display: flex;
  justify-content: space-evenly;
  left: 0;
  flex-wrap: wrap;
}
@media only screen and (max-width: 768px) {
  .col-xs-12 {
    padding-left: 0;
    padding-right: 0;
  }
  .module-small {
    height: 239px;
  }
  .steam-btn {
    width: 100%;
    margin-bottom: 10px;
    max-width: 300px;
  }
  .steam-btn span {
    font-size: 24px;
  }
}

.actions-wrap {
  position: absolute;
  bottom: 40px;
}

a.store-link {
  padding: 20px;
}

h1.comingSoonText span {
  font-size: 35px;
  display: block;
}

@media only screen and (min-device-width: 500px) and (max-device-width: 900px) {
  a.store-link {
    padding: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Home/HeroHeader2.vue